export const animations = {
  fadeIn: 'animate__animated animate__fadeIn',
  fadeOut: 'animate__animated animate__fadeOut',
  fadeDown: 'animate__animated animate__fadeInDown',
  // fadeIn: 'animate_animated animate_fadeIn',
}